import Section from '../components/Section';
import MoleculeDecor from '../components/MoleculeDecor';
import { PHILOSOPHY_CARDS, INNOVATION_STEPS, PHILOSOPHY_SECTIONS, POPULAR_VIDEOS } from '../constants/philosophy';
import styles from './Philosophy.module.css';

// SVG-иконки (те же что на главной)
const ICONS = {
  shield: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  data: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  person: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  science: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v11l6 7M9 3h6m0 0v11l-6 7" />
    </svg>
  ),
};

const Philosophy = () => (
  <>
    {/* Hero-шапка страницы */}
    <section className={styles.pageHero}>
      <MoleculeDecor style={{ right: '3%', top: '50%', transform: 'translateY(-50%) rotate(25deg)', width: 200, height: 200, opacity: 0.55 }} />
      <div className="container">
        <h1 className={styles.pageHeroTitle}>Наша Философия</h1>
        <p className={styles.pageHeroSubtitle}>
          Превентивная медицина — это не мода. Это обоснованная научная стратегия
          управления здоровьем, которая позволяет жить дольше и качественнее.
        </p>
      </div>
    </section>

    {/* Вводный манифест */}
    <Section bg="white">
      <div className={styles.manifesto}>
        <p className={styles.manifestoLead}>
          Сегодня большинство решений в здоровье направлены на устранение симптомов.
        </p>
        <p className={styles.manifestoText}>
          Мы пытаемся исправить кожу у косметолога, вес — с помощью диет, усталость — кофе
          и стимуляторами. Но во многих случаях проблема лежит гораздо глубже — в базовых
          механизмах работы организма.
        </p>
        <p className={styles.manifestoText}>
          Эндокринология и превентивная медицина работают именно на этом уровне. Они помогают
          выстроить фундамент здоровья — сон, питание, метаболизм и гормональную регуляцию.
        </p>
        <p className={styles.manifestoAccent}>
          Когда эта база работает правильно, организм начинает восстанавливаться системно,
          а результат становится более устойчивым и предсказуемым.
        </p>
      </div>
    </Section>

    {/* Блоки с расширенным описанием */}
    <Section bg="gray">
      <div className={styles.sections}>
        {PHILOSOPHY_SECTIONS.map((section, index) => (
          <div key={section.id} className={`${styles.textBlock} ${index % 2 === 1 ? styles.textBlockAlt : ''}`}>
            <div className={styles.textBlockNumber}>{String(index + 1).padStart(2, '0')}</div>
            <div className={styles.textBlockContent}>
              <h2 className={styles.textBlockTitle}>{section.title}</h2>
              <p className={styles.textBlockText}>{section.content}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>

    {/* Популярные видео */}
    <Section
      bg="white"
      title="Популярные видео Романа Терушкина"
      subtitle="Посмотрите самые востребованные выпуски, чтобы понять наш подход"
    >
      <div className={styles.videosGrid}>
        {POPULAR_VIDEOS.map((video) => (
          <div key={video.id} className={styles.videoCard}>
            <div className={styles.videoThumb}>
              {video.thumbnail && (
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className={styles.videoThumbImg}
                />
              )}
              <svg className={styles.videoPlayIcon} viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
            <div className={styles.videoInfo}>
              <h3 className={styles.videoTitle}>{video.title}</h3>
              <span className={styles.videoDuration}>{video.duration}</span>
            </div>
            <a href={video.url} className={styles.videoBtn} target="_blank" rel="noopener noreferrer">
              Смотреть
            </a>
          </div>
        ))}
      </div>
    </Section>

    {/* Четыре принципа */}
    <Section
      bg="gray"
      title="Четыре принципа нашей работы"
      subtitle="Эти ценности определяют каждое решение, которое мы принимаем для наших членов"
    >
      <div className={styles.principlesGrid}>
        {PHILOSOPHY_CARDS.map((card) => (
          <div key={card.id} className={styles.principleCard}>
            <div className={styles.principleIcon}>{ICONS[card.icon]}</div>
            <h3 className={styles.principleTitle}>{card.title}</h3>
            <p className={styles.principleDesc}>{card.description}</p>
          </div>
        ))}
      </div>
    </Section>

    {/* Методика — три шага */}
    <Section
      bg="white"
      title="Наша методика"
      subtitle="Структурированный процесс, который превращает данные в конкретные результаты"
    >
      <div className={styles.methodology}>
        {INNOVATION_STEPS.map((step) => (
          <div key={step.number} className={styles.methodStep}>
            <div className={styles.methodStepHead}>
              <span className={styles.methodStepNumber}>{step.number}</span>
              <h3 className={styles.methodStepTitle}>{step.title}</h3>
            </div>
            <p className={styles.methodStepDesc}>{step.description}</p>
          </div>
        ))}
      </div>
    </Section>
  </>
);

export default Philosophy;
